import React from "react";
import { ConfirmationModal } from "../../../shared/components/common";
import { ReactComponent as Delete } from "../../../assets/icons/delete-fill.svg";

const DeleteUserModal = ({ show, onCancel, onConfirm, count }) => {
  const isMultiple = count && count > 1;

  return (
    <ConfirmationModal
      show={show}
      onCancel={onCancel}
      onConfirm={onConfirm}
      title={isMultiple ? "Delete Users" : "Delete User"}
      messages={[
        isMultiple
          ? `Are you sure you want to delete ${count} user(s)? This action cannot be undone.`
          : "Are you sure you want to delete this user? This action cannot be undone.",
      ]}
      confirmText="DELETE"
      cancelText="CANCEL"
      confirmColor="error"
      cancelColor="primary"
      IconComponent={Delete}
      iconClassName="w-20 h-24"
    />
  );
};

export default DeleteUserModal;
